module.exports = __webpack_public_path__ + "static/media/NewLogo.b32399d6.jpg";